@import 'styles/mixins';
@import 'styles/variables';

.samlSettings {
  margin-top: 32px;
}

.idpMetadataRadioGroup {
  display: flex;
}

.idpMetadataLabel {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.idpMetadataRadio {
  margin-left: 16px;
}

.inRadio {
  width: 100%;
  margin-top: unset !important;
}

.helpText {
  @include md-regular;

  color: $grey-40;
  margin-top: 8px;
  width: 75%;
}

.reachOutText {
  @include md-regular;
  color: var(--neutral-40);
  margin-bottom: 12px;
}
